import Model from './Model';

export class Register extends Model {

	// Default attributes that define the "empty" state.
	defaults() {
		return {
			accountName: '',
			realName: '',
			email: '',
			password: '',
			passwordConfirm: '',
			token: null,
			turnstileToken: '',
		};
	}

	// Route configuration
	routes() {
		return {
			create: '/guest/register',
		};
	}

}
